import React, { useState, useEffect } from 'react';

import './styles.css';

import convertAgeGroup from '../../../../services/dataConverters/convertAgeGroud';

import ClassesCard from './ClassesCard';

export default function ClassesGroup(props) {
    const [classesData, setClassesData] = useState([]);

    useEffect(() => {
        setClassesData(props.classesData);
    }, [props.classesData]);

    return (
        classesData && classesData.length !== 0 ?
            <li className='classes-group'>
                <h3>Turmas {props.classesRef ? props.classesRef : 'sem referêcia'}</h3>
                <hr />
                <ul>
                    {
                        classesData.map((item, index) =>
                            <ClassesCard
                                key={item.id}
                                id={item.id}
                                classRef={item.nome}
                                type={item.tipo}
                                students={item.numero_alunos}
                                ageGroup={convertAgeGroup(item.faixa_etaria)}
                                vacancies={item.numero_vagas - item.numero_alunos}
                                onDelete={() => props.onDelete(item)}
                                coachMode={props.coachMode}
                            />
                        )
                    }
                </ul>
            </li>
            : []
    )
}